import Link from 'next/link';
import GlowBar from 'components/GlowBar';
import NextWinnerBanner from 'components/NextWinnerBanner';
import { colors } from 'utils/constants';
import React from 'react';
import SocialShareButtons from 'components/prizes/SocialShareButtons';
import BackButton from 'components/BackButton';
import { BLOG_ARTICLES } from 'constants/Blogs';
import { useRouter } from 'next/router';

const BlogArticle = ({
  imageDirectory,
  heroAltText,
  children,
  heroImageYPosition = '50%',
}) => {
  const router = useRouter();
  const publishedOn = BLOG_ARTICLES.find(
    (blogArticle) => blogArticle.href === router.pathname,
  )?.datePostedString;
  return (
    <div className="articleContainer">
      <div style={{ width: '100%' }}>
        <NextWinnerBanner style={{ position: 'absolute' }} />
        <img
          src={`${imageDirectory}/hero.jpg`}
          className="heroImage"
          alt={heroAltText}
        />
      </div>

      <div
        className="paddedMaxWidthContainer article"
        style={{ padding: '1.3em' }}
      >
        {children}

        <div
          style={{ fontWeight: 700, textAlign: 'center', marginTop: '2.5em' }}
        >
          Like it? Share it!
          <SocialShareButtons emailSubject="Check out this DAYMADE blog post!" />
          {publishedOn && (
            <p
              style={{
                textAlign: 'center',
                fontStyle: 'italic',
                marginTop: '2em',
                color: '#666',
              }}
            >
              Published on {publishedOn}
            </p>
          )}
        </div>

        <Link href="/blog" passHref>
          <BackButton />
        </Link>
      </div>

      <GlowBar direction="up" color="#D7FBF4" className="glowBar" />

      <style jsx>{`
        .articleContainer {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
        }

        .heroImage {
          width: 100%;
          height: 280px;
          object-fit: cover;
          object-position: 50% ${heroImageYPosition};
        }

        @media (min-width: 500px) {
          .heroImage {
            height: 400px;
          }
        }

        @media (min-width: 1600px) {
          .heroImage {
            height: 500px;
          }
        }

        :global(.article h1) {
          text-shadow: 2px 2px ${colors.brand.pastel};
          margin: 1em 0 0.5em 0;
        }

        :global(.subheading) {
          font-style: italic;
          font-weight: bold;
          text-align: center;
          font-size: 1.3em;
        }

        :global(.article h4) {
          width: 100%;
          text-align: left !important;
          text-shadow: 2px 2px ${colors.brand.pastel};
          margin-top: 1em;
        }

        :global(p) {
          width: 100%;
          text-align: left;
          font-size: 1.1em;
        }
        .articleContainer :global(p a[href]) {
          text-decoration: underline;
        }

        :global(.footer) {
          margin-top: 0 !important;
        }

        :global(.singleBlogImage) {
          margin: 2.5em;
          min-width: 300px;
          max-width: min(100%, 500px);
        }

        :global(.blogFloatContainer) {
          overflow: hidden;
        }
        :global(.floatLeftOnDesktopBlogImage) {
          display: block;
          margin: 2.5em auto;
          max-width: min(100%, 500px);
        }
        @media (min-width: 768px) {
          :global(.floatLeftOnDesktopBlogImage) {
            float: left;
            width: 50%;
            margin-top: 0;
            margin-right: 2em;
          }
        }

        :global(.doubleImageContainer) {
          display: flex;
          justify-content: space-between;
          max-height: 300px;
          overflow: hidden;
          margin: 2.5em 0;
        }
        :global(.doubleImageContainerTaller) {
          max-height: 500px;
        }

        :global(.doubleBlogImage) {
          width: 49.5%;
          object-fit: cover;
          object-position: 50% 50%;
        }

        :global(.quote) {
          font-style: italic;
        }
      `}</style>
    </div>
  );
};

export default BlogArticle;
